/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Health11Inputs */

const en__field_enum_icsrm_health11 = /** @type {(inputs: _Field_Enum_Icsrm_Health11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Health & Medicine`)
};

const de__field_enum_icsrm_health11 = /** @type {(inputs: _Field_Enum_Icsrm_Health11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesundheit & Medizin`)
};

/**
* | output |
* | --- |
* | "Health & Medicine" |
*
* @param {_Field_Enum_Icsrm_Health11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_health11 = /** @type {((inputs?: _Field_Enum_Icsrm_Health11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Health11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_health11(inputs)
	return de__field_enum_icsrm_health11(inputs)
});
export { _field_enum_icsrm_health11 as "_field_enum_ICSRM_HEALTH" }